import { ITEM_DETAIL_PURCHASE_HISTORY_QUERY } from '@/components/orders/item-details-sheet';
import { useQuery } from '@apollo/client';

export const useItemPurchaseHistory = (
  chatUUID: string,
  externalItemID: string | undefined,
  itemUUID: string | undefined,
) => {
  const { data, loading, error } = useQuery(
    ITEM_DETAIL_PURCHASE_HISTORY_QUERY,
    {
      skip: !chatUUID || !(itemUUID || externalItemID),
      variables: {
        chatUUID,
        externalItemID,
        itemUUID,
      },
    },
  );

  return {
    error,
    itemPurchaseHistoryData: data?.getVariantPackPurchaseHistory ?? [],
    loading,
  };
};
